<template>
  <Nav :collectionBalance="collections[0] ? collections[0].balance : ''" />
  
  <div class="bg-red-500 text-white" v-if="networkVersion != '1' && networkVersion != ''">You're on {{network}} network. <small>(Network version {{networkVersion}})</small></div>
  
  <About :collectionBalance="collections[0] ? collections[0].balance : ''" />
  <Collection
    v-for="index in numberOfCollections"
    :key="index"
    :collectionId="index - 1"
  />

    <AccountCollection
    v-if="owner != undefined"
    :owner="owner"
    :collectionId="0" />
  <Footer />
</template>

<script>
import Nav from "./components/Nav.vue";

import Collection from "./components/Collection.vue";
import AccountCollection from "./components/AccountCollection.vue";

import About from "./components/About.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Nav,

    Collection,
    AccountCollection,
    About,
    Footer,
  },
  computed: {

    network() {

      switch(this.networkVersion){
        case '1':
          return 'Main';
        case '4':
          return 'Rinkeby';
        case '3':
          return 'Ropsten';
        case '42':
          return 'Kovan';
        case '5':
          return 'Goerli Test';
        
        default:
          return 'Unknown';
      }


    }
  },

  async mounted() {

    this.emitter.on('provider-detected', () => {
      
      this.networkVersion = this.web3Client.eth.currentProvider.networkVersion;

    });

    
    this.emitter.on('ethereum-enabled', (account) => {
      
      this.owner = account;

    });
    
      this.numberOfCollections = await this.artburnDapp.methods
        .numberOfCollections()
        .call();

        

      for (let i = 0; i < this.numberOfCollections; i++) {
        let collection = await this.artburnDapp.methods.collection(i).call();
        this.collections.push(collection);
      }
  

  },
  data() {
    return {
      numberOfCollections: 0,
      collections: [],
      networkVersion:'',
      owner:undefined
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
</style>
